import React from "react";
import FlowMode from "@/models/enums/flow-mode.ts";
import useProjectCreationContext from "../context/use-project-creation-context.ts";

const CreateProjectTypeStep: React.FC = () => {
    const {setFlowModeCreationProject} = useProjectCreationContext();

    return (
        <div className='flex flex-col gap-y-4 text-white'>
            <button className='group bg-blue-400 rounded' onClick={() => {
                setFlowModeCreationProject(FlowMode._2D3D);
            }}>
                <div className='flex flex-col gap-y-1.5 justify-center py-2 px-4 max text-left h-20 cursor-pointer'>
                    <span className='font-semibold'>PDF simples</span>
                    <span className="h-0 overflow-hidden opacity-0 transition-all duration-300 ease-in-out group-hover:h-6 group-hover:opacity-100">
                        Créez votre projet à partir de vos plans PDF.
                    </span>
                </div>
            </button>

            <button className='group bg-blue-400 rounded' onClick={() => {
                setFlowModeCreationProject(FlowMode._2D3DAdvanced);
            }}>
                <div className='flex flex-col gap-y-1.5 justify-center py-2 px-4 max text-left h-20 cursor-pointer'>
                    <span className='font-semibold'>PDF superposés</span>
                    <span className="h-0 overflow-hidden opacity-0 transition-all duration-300 ease-in-out group-hover:h-6 group-hover:opacity-100">
                        Structurez vos plans PDF et créez votre projet 2D → 3D.
                    </span>
                </div>
            </button>

            <button className='group bg-blue-400 rounded'
                    onClick={() => {
                        setFlowModeCreationProject(FlowMode._3D2D);
                    }}>
                <div className='flex flex-col gap-y-1.5 justify-center py-2 px-4  max text-left h-20'>
                    <span className='font-semibold'>BIM</span>
                    <span className="h-0 overflow-hidden opacity-0 transition-all duration-300 ease-in-out group-hover:h-6 group-hover:opacity-100">
                        Créez votre projet à partir de vos maquettes 3D.
                    </span>
                </div>
            </button>
        </div>
    );
};


export default CreateProjectTypeStep;